import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGameEngine = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polygon", {
			points: "24,6 42,38 6,38",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			points: "24,14 36,34 12,34",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinejoin: "round",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 28,
			r: 3,
			fill: "currentColor",
			opacity: .5
		})
	]
});
export default SvgGameEngine;
